<template>

</template>

<script>
export default {
  name: 'footer-component',
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/site_include/FooterComponent.vue